import type { Path, UseFormReturn } from 'react-hook-form';

/**
 * Validates a set of form fields and returns their combined validity
 * @param form - The form instance
 * @param fieldNames - Array of field names to validate
 * @returns Promise<boolean> - true if all fields are valid
 */
async function validateFields<T extends Record<string, unknown>>(form: UseFormReturn<T>, fieldNames: Path<T>[]): Promise<boolean> {
  const validationPromises = fieldNames.map(fieldName => form.trigger(fieldName));
  const results = await Promise.all(validationPromises);
  return results.every(result => result === true);
}

export { validateFields };
